import React, { Component, useState } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Container } from 'react-bootstrap';
import './Header.scoped.scss'
import AddVenue from '../modals/add-venue/AddVenue';
import ButtonComponent from '../button/Button';

const Header = () => {
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };
        return (
            <section className='header container-fluid'>
                <div className="text-container">
                    <span className="full-text"><span className='dude'>Dude</span>Where'sMyBar</span>
                </div>
                <ButtonComponent 
                    buttonType="Primary"
                    buttonStyle="Plain" 
                    buttonText="Add a Venue" 
                    icon={faPlus} 
                    onClick={handleShow}
                />
                <AddVenue 
                    size="lg"
                    show={showModal}
                    handleClose={handleClose}
                    >

                </AddVenue>
            </section>
        );
    
}

export default Header;